import React from "react";
import {
  GridRow,
  GridColumn,
  Input,
  Icon,
  InputProps,
} from "@metsooutotec/modes-react-components";

import styles from "./sensor-input-fields.module.css";

export interface SensorFormField {
  id: string;
  label: string;
  placeholder: string;
  type: string;
  isRequired: boolean;
  validate?: (value: string) => string;
  disabled?: boolean;
}
interface SensorInputFieldsProps {
  formData: Record<string, string>;
  formErrors: Record<string, string>;
  handleChange: (fieldName: string, value: string) => void;
  handleValidation: (
    fieldName: string,
    validationError: string | undefined
  ) => void;
  onClearClick: (inputId: string) => void;
  inputStrings: Array<SensorFormField>;
}

const SensorInputFields: React.FC<SensorInputFieldsProps> = ({
  formData,
  formErrors,
  handleChange,
  handleValidation,
  onClearClick,
  inputStrings,
}) => {
  return (
    <GridRow>
      {inputStrings.map((input) => {
        const clearIcon = formData[input.id] && !input.disabled && (
          <Icon
            name="icon-cross-circle-fill-16"
            onClick={() => onClearClick(input.id)}
          />
        );

        const inputProps: InputProps = {
          id: input.id,
          label: input.label,
          placeholder: input.placeholder,
          validate: input.validate,
          onValidation: (validationError: string | undefined) =>
            handleValidation(input.id, validationError),
          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            handleChange(input.id, e.target.value),
          type: input.type,
          error: formErrors[input.id],
          value: formData[input.id],
          spanning: true,
          required: input.isRequired,
          uiRequired: input.isRequired,
          icon: clearIcon,
          heightClass: "small",
          disabled:input.disabled
        };
        return (
          <GridColumn key={input.id} className={styles.sensorInputColumn}>
            <Input {...inputProps} />
          </GridColumn>
        );
      })}
    </GridRow>
  );
};

export default SensorInputFields;
